import { useEffect } from 'react';

var useAutoResize = function useAutoResize(targetEl, maxHeight) {
  useEffect(function () {
    var handleResize = function handleResize() {
      targetEl.style.height = 'auto';
      var scrollHeight = targetEl.scrollHeight,
        clientHeight = targetEl.clientHeight;
      var newHeight = clientHeight;
      if (maxHeight > newHeight) {
        newHeight = Math.min(maxHeight, Math.max(scrollHeight, newHeight));
        if (scrollHeight > maxHeight) {
          targetEl.style.overflow = 'auto';
        } else {
          targetEl.style.overflow = 'hidden';
        }
        if (newHeight > clientHeight) {
          targetEl.style.height = "".concat(newHeight, "px");
        }
      }
    };
    if (targetEl && maxHeight) {
      handleResize();
      targetEl.addEventListener('keyup', handleResize, true);
    }
    return function () {
      targetEl === null || targetEl === void 0 ? void 0 : targetEl.removeEventListener('keyup', handleResize, true);
    };
  }, [targetEl, maxHeight]);
};

export { useAutoResize };
